import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UploadMacAddressService } from '../../../shared/services/upload-mac-address/upload-mac-address.service'
import { AlertService } from "../../../shared/services/alert/alert.service";
import Swal from "sweetalert2";
import { first } from "rxjs/operators";

@Component({
  selector: 'app-mac-address-details',
  templateUrl: './mac-address-details.component.html',
  styleUrls: ['./mac-address-details.component.scss']
})
export class MacAddressDetailsComponent implements OnInit {

  macaddress: any = {
    testcenterid: "",
    primarymacid: "",
    secondarymacid: "",
    primarybackupmacid: "",
    secondarybackupmacid: "",
  };
  sender = "mac-address-details";
  macId: any;
  error: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private uploadMacAddressService: UploadMacAddressService,
    private alertService: AlertService,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.macId = params.get("id");
      if (!this.isNew()) {
        this.getMacAddressById();
      }
    });
  }

  isNew() {
    return this.macId == "new";
  }

  getMacAddressById() {
    this.uploadMacAddressService
      .getMacAddressById(this.macId)
      .pipe(first())
      .subscribe(res => {
        this.macaddress = res;
      });
  }

  onSave() {

    if (!this.macaddress.testcenterid) {
      this.error = "Testcenter Id can not be blank";
      this.alertService.err(this.sender, this.error)
      return false;
    }

    if (!this.macaddress.primarymacid) {
      this.error = "Primary MAC Id can not be blank";
      this.alertService.err(this.sender, this.error)
      return false;
    }

    if (!this.macaddress.secondarymacid) {
      this.error = "Secondary MAC Id can not be blank";
      this.alertService.err(this.sender, this.error)
      return false;
    }

    this.uploadMacAddressService
      .saveMacAddress(this.macaddress)
      .pipe(first())
      .subscribe(res => {
        if (res["status"] == "error") {
          this.alertService.err(this.sender, res["message"]);
          return;
        }
        this.alertService.show(this.sender, "MAC Address data Saved");
        setTimeout(() => {
          this.router.navigate(["manager/mac-address-list"]);
        }, 1000);

      });
  }

  Ondelete() {
    Swal.fire({
      title: "Are you sure?",
      text:
        "MAC address will be deleted. This action can't be reversed!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it"
    }).then(result => {
      if (result.value) {
        this.uploadMacAddressService
          .deleteMacAddressById(this.macId)
          .pipe(first())
          .subscribe(res => {
            this.onCancel();
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.router.navigate(["manager/mac-address-list/" + this.macId]);
      }
    });
  }

  onCancel() {
    this.router.navigate(["/manager/mac-address-list"]);
  }



}
